import { get, post, remove, put } from '../services/common/common.service';
import { contractsEndPoints, commonEndPoints } from '../constants/endpoint';

//Contracts Search by Id - GET API to fetch the data as per payload
export const fetchContractsSearchById = (payload) =>
  get(
    `${contractsEndPoints.contractsSearchById}?contractId=${payload}`,
    payload
  );

//Accounting Group Smart Search - POST API to fetch the data as per payload
export const fetchAccountingGroupsData = (payload) => {
  return post(contractsEndPoints.accountingGroup, payload);
};

//Country Smart Search - POST API to fetch the data as per payload
export const fetchCountriesData = (payload) =>
  post(commonEndPoints.countrySearch, payload);

//Customer Smart Search - POST API to fetch the data as per payload
export const fetchCustomerData = (payload) =>
  post(contractsEndPoints.customer, payload);

//BillTo Smart Search - POST API to fetch the data as per payload
//We are using the same API for BillTo and Site
export const fetchBillToData = (payload) =>
  post(contractsEndPoints.billTo, payload);

//Customer Smart Search - POST API to fetch the data as per payload
export const fetchSiteData = (payload) =>
  post(contractsEndPoints.siteSearch, payload);

export const fetchSiteSearchData = (payload) =>
  post(contractsEndPoints.siteSearch, payload);

//Status Smart  Search - POST API to fetch the data as per payload
export const fetchStatusData = (payload) =>
  get(contractsEndPoints.status, payload);

//Level DropDown - GET API to fetch the data as per payload
export const fetchLevelData = (payload) =>
  get(contractsEndPoints.level, payload);

//Level DropDown - GET API to fetch the data as per payload
export const fetchContractsSearch = (payload) =>
  post(contractsEndPoints.contractsSearch, payload);

export const fetchApprovalsData = (payload) =>
  post(contractsEndPoints.approvals, payload);

// Site and BillTo Smart Search - POST API to fetch the data as per payload
export const fetchSiteAndBillToData = (payload) =>
  post(contractsEndPoints.billToAndSiteSearch, payload);

// Site Type DropDown - GET API to fetch the data
export const fetchSiteTypeData = () => get(contractsEndPoints.siteType);
// orderable tab apis

//search box modal pop up product service name/code api

export const searchProductCodeName = (payload) =>
  post(contractsEndPoints.salesMapping.productNameCodeSearch, payload);

//dropdown service level name api
export const fetchServiceLevelName = () =>
  get(contractsEndPoints.salesMapping.serviceLevelName);

//delete orderable grid row api
export const deleteOrderable = (payload) => {
  return remove(contractsEndPoints.salesMapping.deleteOrderable, payload);
};

//save  orderable grid data api
export const saveOrderable = (payload) => {
  return post(contractsEndPoints.salesMapping.saveOrderable, payload);
};

//get orderable existing data
export const fetchOrderableData = (payload) => {
  return get(
    `${contractsEndPoints.salesMapping.fetchOrderableData}?contractId=${payload.contractId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
    payload
  );
};

// fetch orderable compare data

export const fetchOrderableCompareData = (payload) => {
  return get(
    `${contractsEndPoints.salesMapping.fetchOrderableData}?contractId=${payload.contractId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
    payload
  );
};

//supported tab
//get supported  grid data
//override data
export const fetchSupportedOverride = (payload) =>
  get(
    `${contractsEndPoints.salesMapping.fetchSupported}?contractId=${payload.contractId}&erpSalesProductId=${payload.erpSalesProductId}`
  );

//get supported  data
export const fetchSupported = (payload) => {
  return post(contractsEndPoints.salesMapping.fetchSupported, payload);
};

//zone grid api
export const fetchSupportedZone = (payload) =>
  get(
    `${contractsEndPoints.salesMapping.fetchSupportedZone}?contractId=${payload.contractId}&erpSalesProductId=${payload.erpSalesProductId}`
  );

// remove supported
export const deleteSupported = (payload) => {
  return post(contractsEndPoints.salesMapping.deleteSupported, payload);
};
//unsupported tab
export const searchUnsupportedReport = (payload) => {
  return post(contractsEndPoints.salesMapping.unsupported, payload);
};

//add associate sales order apis
//search sales order to associate api
export const searchSalesOrder = (payload) => {
  return post(contractsEndPoints.salesMapping.searchSalesOrder, payload);
};

//add clicked sales order on cell selection api
export const addUnsupportedSales = (payload) => {
  return post(`
${contractsEndPoints.salesMapping.addUnsupportedSalesProduct}?contractId=${payload.contractId}&productId=${payload.productId}&userId=${payload.userId}`);
};

//delete sales associate record
export const deleteUnsupported = (payload) => {
  return remove(
    `
${contractsEndPoints.salesMapping.deleteUnsupported}?contractId=${payload.contractId}&productId=${payload.productId}`,
    payload
  );
};

//sales order tab
export const searchSalesOrderReport = (payload) => {
  return post(contractsEndPoints.salesMapping.searchSalesOrderReport, payload);
};

export const searchHigherSalesOrderReport = (payload) => {
  return post(
    contractsEndPoints.salesMapping.searchHigherSalesOrderReport,
    payload
  );
};

export const saveSalesOrderHOCReport = (payload) => {
  return post(
    contractsEndPoints.salesMapping.deleteHigherSalesOrderReport,
    payload
  );
};

// create new contract api
export const createNewContract = (payload) => {
  return post(contractsEndPoints.createNewContract, payload);
};

// notes tab apis - Notes: Notes Type 2 / Audit Trail: Notes Type - 1
export const fetchNotes = (payload) =>
  get(
    `${contractsEndPoints.notesTab.getNote}?contractId=${payload.contractId}&noteTypeId=${payload.noteTypeId}`,
    payload
  );

// post notes
export const postNotes = (payload) => {
  return post(contractsEndPoints.notesTab.postNote, payload);
};

//warranty and extended service tab

export const getPriceClassesServiceOfferingsData = (payload) => {
  return post(
    contractsEndPoints.warrantyExtendedPeriod.fetchServiceOfferingData,
    payload
  );
};
//deferralPriceClassCheck
export const getDeferralPriceClassess = (payload) => {
  return post(
    contractsEndPoints.warrantyExtendedPeriod.deferralPriceClassSearchByCountry,
    payload
  );
};
//extendedServiceSave
export const extendedWarrentitySave = (payload) => {
  return post(
    contractsEndPoints.warrantyExtendedPeriod.extendedWarrantySave,
    payload
  );
};
//Get WarrantyExtended PriceClass
export const getContractPriceClasses = (payload) => {
  return post(
    `${contractsEndPoints.warrantyExtendedPeriod.fetchContractPriceClasses}`,
    payload
  );
};

//Get WarrantyExtended PriceClass Options
export const getPriceClassWithServices = (payload) => {
  return post(
    contractsEndPoints.warrantyExtendedPeriod.fetchContractPriceClassOptions,
    payload
  );
};

//Get WarrantyExtended PriceClass ServiceOffeings
export const getContractServiceOfferings = (payload) => {
  return post(
    contractsEndPoints.warrantyExtendedPeriod.fetchContractServiceOfferings,
    payload
  );
};

//selected options Tab

export const updateSelectedOptions = (payload) => {
  const url = `${contractsEndPoints.selectedOptionsTab.updateSelectedOptionsData}/${payload.id}`;
  return put(url, payload);
};
//contractBillSets

export const getContractBillSets = (payload) => {
  return get(
    contractsEndPoints.selectedOptionsTab.getContractBillSets,
    payload
  );
};

//Contract cycles

export const getContractBillCycles = (payload) => {
  return get(contractsEndPoints.selectedOptionsTab.getEmBillCycle, payload);
};

//DefaultPricingOptions

export const getDefaultPriceOptions = (payload) => {
  return get(
    `${contractsEndPoints.selectedOptionsTab.getDefaultPricingOptions}?contractId=${payload.contractId}`,
    payload
  );
};

//contractHistory Data

export const getContractHistory = (payload) => {
  return get(
    `${contractsEndPoints.contractHistoryTab.getContractHistory}?ContractId=${payload.contractId}&recordsPerPage=${payload.recordsPerPage}&pageIndex=${payload.pageIndex}`,
    payload
  );
};

//contractHistory CPI Data
export const getContractHistoryCPI = (payload) => {
  return get(
    `${contractsEndPoints.contractHistoryTab.getContractHistoryCPI}?ContractId=${payload.contractId}&recordsPerPage=${payload.recordsPerPage}&pageIndex=${payload.pageIndex}`,
    payload
  );
};

//contractHistory viewBackup

export const contractHistoryViewBakup = (payload) => {
  return post(
    contractsEndPoints.contractHistoryTab.contractHistoryBackup,
    payload
  );
};

//contractHistory returnCreate

export const contractReturnToCreate = (payload) => {
  return post(
    `${contractsEndPoints.contractHistoryTab.returnTocreateModify}?contractId=${payload.contractId}`,
    payload
  );
};

export const updatePriceClassOptionsTab = (payload) => {
  return put(
    contractsEndPoints.selectedOptionsTab.updatePriceClassOptionsTab,
    payload
  );
};

//Out Of Scope Tab (Archieved)
//Get countries drop down
export const fetchOOSCountries = (payload) => {
  return get(
    `${contractsEndPoints.contractOOSArchiveTab.getCountries}?billSetId=${payload.billSetId}`,
    payload
  );
};

//Get Hardware Fees
export const fetchHardwareFees = (payload) => {
  //For Archived OOS
  if (payload?.archiveTimestamp) {
    return get(
      `${contractsEndPoints.contractOOSArchiveTab.getHardwareFees}?contractId=${payload.contractId}&archiveTimestamp=${payload.archiveTimestamp}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
      payload
    );
  }
  //For Non Archived OOS
  else {
    return get(
      `${contractsEndPoints.contractOOSArchiveTab.getHardwareFees}?contractId=${payload.contractId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
      payload
    );
  }
};

//Get Hardware Logistic
export const fetchHardwareLogistics = (payload) => {
  //For Archived OOS
  if (payload?.archiveTimestamp) {
    return get(
      `${contractsEndPoints.contractOOSArchiveTab.getHardwareLogistic}?contractId=${payload.contractId}&archiveTimestamp=${payload.archiveTimestamp}&priceClassId=${payload.priceClassId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
      payload
    );
  }
  //For Non Archived OOS
  else {
    return get(
      `${contractsEndPoints.contractOOSArchiveTab.getHardwareLogistic}?contractId=${payload.contractId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
      payload
    );
  }
};

//Get Hardware Logistic AddOn
export const fetchHardwareLogisticsAddOn = (payload) => {
  return get(
    `${contractsEndPoints.contractOOSArchiveTab.getHardwareLogisticAddOn}?contractId=${payload.contractId}&archiveTimestamp=${payload.archiveTimestamp}&priceClassId=${payload.priceClassId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
    payload
  );
};

//Get Labor Fees
export const fetchLaborFees = (payload) => {
  return get(
    `${contractsEndPoints.contractOOSArchiveTab.getLaborFees}?billSetId=${payload.billSetId}&countryId=${payload.countryId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`,
    payload
  );
};

//Update Hardware Fees - Non Stanadard Fees
export const updateHwFeesNonStandard = (payload) => {
  return post(
    contractsEndPoints.contractsOOSTab.updatePriceClassHwFeesNsFee,
    payload
  );
};

//Update Hardware Logistics - Non Stanadard Fees
export const updateHwLogisticsNonStandard = (payload) => {
  return post(
    contractsEndPoints.contractsOOSTab.updateServiceOfferingHwLogisticNsFee,
    payload
  );
};

//Update Hardware Logistics Non standard consumable fee
export const updateHwLogisticsNonStandardConsumableFee = (payload) => {
  return post(
    `${contractsEndPoints.contractsOOSTab.updateLogisticsNonStdConsumableFee}?nonStdConsumableFee=${payload.nonStdConsumableFee}&contractId=${payload.contractId}&userId=${payload.userId}`,
    payload
  );
};

export const getDeferralServiceOfferings = (payload) => {
  return get(
    `${contractsEndPoints.warrantyExtendedPeriod.fetchDeferralServiceOffering}?contractId=${payload.contractId}&priceClassId=${payload.priceClassId}`
  );
};

export const returnToCreateNewContract = (payload) => {
  return post(`${contractsEndPoints.returnToCreate}?contractId=${payload}`);
};

export const getSelectedOptionsPriceClasses = (payload) => {
  return post(
    `${contractsEndPoints.warrantyExtendedPeriod.fetchContractPriceClasses}`,
    payload
  );
};

// create submit approval
export const createSubmitSave = (payload) => {
  return post(
    `${contractsEndPoints.createsubmitApproval}?contractId=${payload.contractId}&comment=${payload.comment}&userId=${payload.userId}`
  );
};

export const selectedOptionDefferalServiceOffering = (payload) => {
  return get(
    `${contractsEndPoints.warrantyExtendedPeriod.selectedOptionDefferalServiceOffering}?contractId=${payload.contractId}&priceClassId=${payload.priceClassId}`
  );
};

export const contractDetailsById = (payload) => {
  return get(
    `${contractsEndPoints.copyContract.contractDetailsById}?contractId=${payload}`
  );
};

export const searchContaractData = (payload) => {
  return post(contractsEndPoints.copyContract.searchContract, payload);
};

export const priceAndServiceMapData = (payload) => {
  return get(
    `${contractsEndPoints.copyContract.CountContractPriceAndServicesMap}/${payload}`
  );
};

export const getCopyContract = (payload) => {
  return post(contractsEndPoints.copyContract.copyContract, payload);
};

export const approvalContract = (payload) => {
  return post(contractsEndPoints.approvalContract, payload);
};

export const trickleContract = (payload) => {
  return post(
    `${contractsEndPoints.trickleContract}`,
    payload
  );
};

export const trickleDownContractChange = (payload) => {
  return put(
    `${contractsEndPoints.trickleDownContractChange}?contractId=${payload?.contractId}&userId=${payload?.userId}`
  );
};

export const saveContractDescription = (payload) => {
  return put(
    `${contractsEndPoints.saveContractDescription}?contractId=${payload.contractId}&desciption=${payload?.desciption}&userId=${payload?.userId}`,
    payload
  );
};

//Related Contracts
export const fetchRelatedContracts = (payload) => {
  return post(
    `${contractsEndPoints.relatedContracts}?contractId=${payload?.contractId}&pageIndex=${payload.pageIndex}&pageSize=${payload.recordCount}`,
    payload
  );
};

// Audit Trail tab apis - Notes: Notes Type 2 / Audit Trail: Notes Type - 1
export const fetchAuditTrail = (payload) =>
  get(
    `${contractsEndPoints.notesTab.getNote}?contractId=${payload.contractId}&noteTypeId=${payload.noteTypeId}`,
    payload
  );
